import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {IntlProvider, addLocaleData} from 'react-intl';
import Highcharts from 'highcharts';
import highchartsLocaleData from '../../../../../../../../i18n/highchartsLocaleData';
import moment from 'moment';
import RoutesContainer from './components/RoutesContainer';

// Import locale data for supported languages
import en from 'react-intl/locale-data/en';
import sv from 'react-intl/locale-data/sv';

// Import moment locale data
import 'moment/locale/sv';

// Our own translated strings
import localeData from '../../../../../../../../i18n/localeData.json';

class IntlContainer extends Component {
  constructor(props) {
    super(props)

    // Add all supported locales
    addLocaleData([...en, ...sv]);

    // ToDo: update this to use the new format 
    // when language format is updated in the db 
    const userLanguage = !!props.viewer.language ? props.viewer.language.slice(0,2).toLowerCase() : 'sv';
    // ToDo: set up fallback in react intl
    // Add all supported translations 
    const language = ['en','sv'].includes(userLanguage) ? userLanguage : 'en';
    const messages = localeData[language];

    this.state = {
      language,
      messages,
    };

    // Set Highcharts language
    if (language !== 'en') {
      Highcharts.setOptions({lang: highchartsLocaleData[language]});
    }

    // Set moment.js language
    moment.locale(language);
  }

  render() {
    return (
      <IntlProvider locale={this.state.language} messages={this.state.messages}>
        <RoutesContainer viewer={this.props.viewer} />
      </IntlProvider>
    )
  }
}

export default createFragmentContainer(
  IntlContainer,
  graphql`
    fragment IntlContainer_viewer on Viewer {
      language
      ...RoutesContainer_viewer
    }
  `,
);



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/IntlContainer.js